import { FilterOutlined } from '@ant-design/icons';
import { Button, Grid } from 'antd';
import { Modal } from 'components/modal/modal';
import { cloneElement, ReactElement, useEffect, useState } from 'react';

import {
  StyledButtonsWrapper,
  StyledFiltersModalWrapper,
  StyledFiltersWrapper,
  StyledFooterWrapper,
  StyledFormItemsWrapper,
} from './content-filters.styles';

type ContentFiltersProps = {
  formId?: string;
  children: ReactElement;
};

const { useBreakpoint } = Grid;

export const ContentFilters = ({ formId, children }: ContentFiltersProps) => {
  const screens = useBreakpoint();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (formId === 'week-view-filters-form') {
      setIsModalOpen(true);
    }
  }, []);

  return (
    <>
      {screens.lg ? (
        <StyledFiltersWrapper>{children}</StyledFiltersWrapper>
      ) : (
        <StyledFiltersModalWrapper>
          <div className='absolute right-0 top-0'>
            <Button onClick={showModal}>
              <FilterOutlined /> Filter
            </Button>
          </div>

          <Modal
            open={isModalOpen}
            onCancel={closeModal}
            title={'Filter Heading'}
            getContainer={false}
            width='100%'
            footer={[
              <StyledFooterWrapper key='footer'>
                <StyledButtonsWrapper>
                  <Button
                    form={formId}
                    key='modal-filters-reset'
                    htmlType='reset'
                    size={screens.lg ? 'middle' : 'large'}
                    className='modal-footer-button'
                  >
                    Reset
                  </Button>
                  <Button
                    form={formId}
                    key='modal-filters-submit'
                    htmlType='submit'
                    size={screens.lg ? 'middle' : 'large'}
                    type='primary'
                    className='modal-footer-button'
                  >
                    Search
                  </Button>
                </StyledButtonsWrapper>
              </StyledFooterWrapper>,
            ]}
          >
            {cloneElement(children, { closeModal })}
          </Modal>
        </StyledFiltersModalWrapper>
      )}
    </>
  );
};

ContentFilters.ButtonsWrapper = StyledButtonsWrapper;
ContentFilters.FormItemsWrapper = StyledFormItemsWrapper;
